<template>
  <Accordion :multiple="true" :activeIndex="[0]">
    <AccordionTab header="Informações do Evento">
      <p><b>NOME DO EVENTO:</b> {{ obj.name }}</p>
      <p><b>DESCRIÇÃO:</b> {{ obj.description }}</p>
      <p v-if="obj.observation"><b>OBSERVAÇÃO:</b> {{ obj.observation }}</p>
      <p>
        <b>INÍCIO:</b> {{ getDtInit() }} &emsp; <b>TÉRMINO:</b>
        {{ getDtFinish() }}
      </p>
      <p>
        <b>STATUS:</b>
        <span :class="`badge status-${obj.status.toLowerCase()}`">{{
          convertStatus(obj.status)
        }}</span
        >&emsp;&emsp;&emsp;&emsp;
        <b> TIPO DO EVENTO:</b>
        <span :class="`badge type-${obj.type.toLowerCase()}`">{{
          convertType(obj.type)
        }}</span>
      </p>
      <p v-if="obj.pae !== null"><b>N° DO PROCESSO:</b> {{ obj.pae }}</p>
      <p>
        <b>CRONOGRAMA DO EVENTO:</b>
        <b v-for="calendar in obj.calendars" :key="calendar.id">
          <br /><span
            ><i class="pi pi-calendar ml-2 mr-2" />{{
              getCalendarDetails(calendar)
            }}</span
          >
        </b>
      </p>
    </AccordionTab>
    <AccordionTab header="Responsável do Evento" v-if="obj.responsible.id">
      <p v-if="obj.responsible.name">
        <b>NOME DO RESPONSÁVEL:</b> {{ obj.responsible.name }}
        &emsp;
        <b v-if="obj.responsible.credential">MATRÍCULA:</b>
        {{ obj.responsible.credential }}
      </p>
      <p v-if="obj.responsible.email">
        <b>E-mail:</b> {{ obj.responsible.email }}
      </p>
    </AccordionTab>

    <AccordionTab header="Local do Evento">
      <p><b>LOCAL SOLICITADO:</b> {{ obj.local.name }}</p>
      <p>
        <b>CAPACIDADE SOLICITADA:</b> {{ obj.nparticipants }}&emsp;
        <b>CAPACIDADE MÍNIMA:</b> {{ obj.local.capMin }}&emsp;
        <b>CAPACIDADE MÁXIMA:</b> {{ obj.local.capMax }}
      </p>
      <p>
        <b>EQUIPAMENTOS:</b>
        <b v-for="equipament in obj.equipaments" :key="equipament.id">
          <br /><span
            ><i class="pi pi-cog ml-2 mr-2"></i>{{ equipament.name }}</span
          >
        </b>
      </p>
    </AccordionTab>

    <AccordionTab v-if="obj.participants" header="Lista de Participantes">
      <b>Listagem: </b>
      <div v-html="obj.participants"></div>
    </AccordionTab>
    <!--
    <AccordionTab header="Histórico">
      <OrderList v-model="historys" listStyle="height:auto" dataKey="id">
        <template #header> Histórico da Solicitação </template>
        <template #item="slotProps">
          <div class="solicitacao-list-detail">
            <h5 class="mb-2">{{ slotProps.item.description }}</h5>
            <i class="pi pi-clock solicitacao-category-icon mr-2"></i>
            <span class="solicitacao-clock">{{
              $DateTime.formatarDateTime24hours(slotProps.item.dtHistory)
            }}</span>
          </div>
        </template>
      </OrderList>
    </AccordionTab>
  -->
  </Accordion>
</template>

<script>
//Enums
import { convertType } from "../../../models/enums/type_event";
import { convertStatus } from "../../../models/enums/status_event";
import Moment from "moment";

export default {
  props: ["obj"],
  data() {
    return {
      convertType,
      convertStatus,
      historys: this.obj.historys,
    };
  },
  // computed: {
  //   historys() {
  //     return this.obj.historys;
  //   },
  // },
  methods: {
    getDtInit() {
      if (this.obj.calendars.length > 0) {
        const date = this.$DateTime.formatarDate(this.obj.calendars[0].date);
        const time = Moment(this.obj.calendars[0].initTime).isValid()
          ? this.$DateTime.formatarDateHour(this.obj.calendars[0].initTime)
          : this.obj.calendars[0].initTime;
        return `${date} ${time}`;
      } else {
        return "";
      }
    },
    getDtFinish() {
      if (this.obj.calendars.length > 0) {
        const length = this.obj.calendars.length - 1;
        const date = this.$DateTime.formatarDate(
          this.obj.calendars[length].date
        );
        const time = Moment(this.obj.calendars[length].endTime).isValid()
          ? this.$DateTime.formatarDateHour(this.obj.calendars[length].endTime)
          : this.obj.calendars[length].endTime;
        return `${date} ${time}`;
      } else {
        return "";
      }
    },
    getCalendarDetails(calendar) {
      const date = this.$DateTime.formatarDate(calendar.date);
      //const initTime = this.$DateTime.formatarDateHour(calendar.initTime);
      //const endTime = this.$DateTime.formatarDateHour(calendar.endTime);

      const initTime = Moment(calendar.initTime).isValid()
        ? this.$DateTime.formatarDateHour(calendar.initTime)
        : calendar.initTime;

      const endTime = Moment(calendar.endTime).isValid()
        ? this.$DateTime.formatarDateHour(calendar.endTime)
        : calendar.endTime;

      return `${date} DE ${initTime} A ${endTime}`;
    },
    getStatus() {
      return this.obj.status == null ? this.obj.status.toLowerCase() : "";
    },
    getDtHistory(dtHistory) {
      var formatedDate = Moment.utc(dtHistory)
        .local()
        .format("DD/MM/YYYY HH:mm:ss");
      return formatedDate;
    },
  },
};
</script>

<style></style>
